var idCounter = 0;
var uniqueId = function () { return ++idCounter; };
export default uniqueId;
//# sourceMappingURL=unique-id.js.map